/**
 * The upload drop zones' `accept` list, built from the server's supported-formats
 * list (GET /documents/supported-formats) so a drop zone accepts exactly what the
 * server does, including the types it converts to PDF when that is on (Excel,
 * CSV, images, HTML). Until the list has loaded (or if it fails) each drop zone
 * keeps its own static list.
 */

import { useMemo } from 'react';
import type { Accept } from 'react-dropzone';
import type { SupportedFormatsResponse } from './api';
import { useSupportedFormats } from '../hooks/useSupportedFormats';

export function acceptFromFormats(data: SupportedFormatsResponse | null, fallback: Accept): Accept {
  if (!data || data.formats.length === 0) return fallback;
  const accept: Accept = {};
  for (const format of data.formats) {
    accept[format.mime_type] = [...new Set([...(accept[format.mime_type] ?? []), ...format.extensions])];
  }
  return accept;
}

export function useUploadAccept(fallback: Accept): Accept {
  const formats = useSupportedFormats();
  return useMemo(() => acceptFromFormats(formats, fallback), [formats, fallback]);
}
